import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, IconButton, useTheme, Zoom } from '@mui/material';
import { Close as CloseIcon, TrendingUp as TrendingUpIcon, Launch as LaunchIcon } from '@mui/icons-material';

export default function NetworthPromoCard() {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show the card after a short delay (e.g. 2.5 seconds) to avoid interrupting immediately
    const timer = setTimeout(() => {
      setVisible(true);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
  };

  return (
    <Zoom in={visible} style={{ transitionDelay: visible ? '100ms' : '0ms' }}>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          width: { xs: 'calc(100% - 32px)', sm: 360 },
          borderRadius: '16px',
          bgcolor: mode === 'light' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(17, 22, 37, 0.95)',
          backdropFilter: 'blur(16px)',
          border: mode === 'light' ? '1px solid rgba(79, 70, 229, 0.15)' : '1px solid rgba(129, 140, 248, 0.2)',
          boxShadow: mode === 'light' 
            ? '0 10px 30px -5px rgba(79, 70, 229, 0.15), 0 8px 10px -6px rgba(79, 70, 229, 0.05)'
            : '0 10px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(129, 140, 248, 0.05)',
          p: 3,
          pr: 4.5,
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            borderColor: mode === 'light' ? 'rgba(79, 70, 229, 0.3)' : 'rgba(129, 140, 248, 0.4)',
          }
        }}
      >
        {/* Close Button */}
        <IconButton
          size="small"
          onClick={handleDismiss}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: 'text.secondary',
            opacity: 0.6,
            '&:hover': {
              opacity: 1,
              bgcolor: 'rgba(0, 0, 0, 0.05)',
            }
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>

        {/* Title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TrendingUpIcon sx={{ color: 'primary.main', fontSize: 22 }} />
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 800,
              fontFamily: '"Outfit", sans-serif',
              color: 'text.primary',
              fontSize: '15px',
              letterSpacing: '-0.01em',
            }}
          >
            Track & Project Your Net Worth
          </Typography>
        </Box>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.5,
            fontSize: '13px',
          }}
        >
          Try our new tool <strong>SeeYourNetworth</strong> to track assets, liabilities, cashflows, and project compound growth up to 40 years.
        </Typography>

        {/* CTA Button */}
        <Button
          href="https://www.seeyournetworth.com/"
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          size="small"
          fullWidth
          endIcon={<LaunchIcon sx={{ fontSize: '14px !important' }} />}
          sx={{
            mt: 0.5,
            py: 1,
            fontSize: '12px',
            borderRadius: '8px',
          }}
        >
          Launch Tracker
        </Button>
      </Box>
    </Zoom>
  );
}
